module.exports = __webpack_public_path__ + "static/sunweb-skin-214e0f63050173557f9007990a3fb592.jpg";